import gql from 'graphql-tag';

export const getEquipmentSettingsOnChannel = gql(/* GraphQL */ `
  query equipmentSettingsOnChannel($channelId: UUID!) {
    equipmentSettingsOnChannel(channelId: $channelId) {
      id
      channel {
        _id
      }
      categories
      locations
    }
  }
`);
